module.exports = __webpack_public_path__ + "static/media/software-hex.b2cee4b2.svg";